import { useMemo } from 'react'
import { View } from 'react-native'
import { AccountOrgBillingSection } from '../AccountOrgBillingSection/AccountOrgBillingSection'
import { AccountInvoiceDetailsSection } from '../AccountInvoiceDetailsSection/AccountInvoiceDetailsSection'
import type { OrgInvoiceProfilePatch } from '../../helpers/orgInvoiceProfile.helper'
import type { Theme } from '../../../theme/getTheme'
import type { B2bAccountDto } from '../../types/b2bAccount.types'
import { getAccountInvoiceDetailsTabStyles } from './AccountInvoiceDetailsTab.styles'

interface AccountInvoiceDetailsTabProps {
  accountId: string | null
  account: B2bAccountDto | null
  theme: Theme
  stripeReturnSyncing?: boolean
  onSaveInvoiceProfile: (patch: OrgInvoiceProfilePatch) => Promise<void>
}

export function AccountInvoiceDetailsTab({
  accountId,
  account,
  theme,
  stripeReturnSyncing = false,
  onSaveInvoiceProfile,
}: AccountInvoiceDetailsTabProps) {
  const styles = useMemo(() => getAccountInvoiceDetailsTabStyles(theme), [theme])

  if (account == null) {
    return null
  }

  return (
    <View style={styles.cardWrap}>
      <View style={styles.container}>
        <AccountOrgBillingSection
          accountId={accountId}
          account={account}
          theme={theme}
          stripeReturnSyncing={stripeReturnSyncing}
        />
        <AccountInvoiceDetailsSection
          account={account}
          theme={theme}
          onSave={onSaveInvoiceProfile}
          showTopDivider
        />
      </View>
    </View>
  )
}
